import { fromJS } from 'immutable';
import { createReducer } from 'redux-create-reducer';
import * as actions from './actions';

export const initialState = fromJS({
  loading: false,
  customers: {},
  customerData: '',
  customerId: ''
});
export default createReducer(initialState, {
  [actions.FETCH_CUSTOMERS]: (state) => state.set('loading', true),
  [actions.FETCH_CUSTOMERS_FAILED]: (state, action) =>
    state.set('loading', false).set('error', action.error),
  [actions.FETCH_CUSTOMERBYID]: (state) => state.set('loading', true),
  [actions.FETCH_CUSTOMERBYID_FAILED]: (state, action) =>
    state.set('loading', false).set('error', action.error),
  [actions.FETCH_CUSTOMERBYID_SUCCESS]: (state, action) => {
    let registeredAddress =
      action.payload.personal_details !== null &&
      action.payload.personal_details.addresses.find((data) => data.effective_period.to === null);
    if (registeredAddress && registeredAddress !== null && registeredAddress !== undefined) {
      registeredAddress = registeredAddress.uk_address;
      return state
        .set('loading', false)
        .set('customerData', fromJS(action.payload))
        .set('personalAddress', fromJS(registeredAddress))
        .set('registeredOrganisationName', registeredAddress.organisation_name)
        .set('registeredAddressFlatNumber', registeredAddress.address_prefix)
        .set('registeredAddressBuildingNumber', registeredAddress.house_number)
        .set('registeredAddressStreetName', registeredAddress.street_name)
        .set('registeredAddressCityName', registeredAddress.city)
        .set('registeredAddressPostcode', registeredAddress.postal_code)
        .set('registeredAddressLine1', registeredAddress.address_line_1)
        .set('registeredAddressLine2', registeredAddress.address_line_2)
        .set('registeredAddressHouseName', registeredAddress.house_name)
        .set('registeredAddressReference', registeredAddress.id)
        .set('tradingFirstName', action.payload.personal_details.name.first_name)
        .set('tradingLastName', action.payload.personal_details.name.last_name);
    }
    return state.set('customerData', fromJS(action.payload));
  },
  FETCH_BUSINESS_CUSTOMERSBYID_SUCCESS: (state, action) =>
    state.set('customerData', fromJS(action.payload))
});
